import { TextField } from "@mui/material";
import { useContext } from "react";

import Context from "../../../context";
import { ManagementCompany } from "../../../types";

export default function Cif({ cif, managementCompanyId }: ManagementCompany) {
	const { actions, state } = useContext(Context);

	const handleOnChangeisin = ({ target }: any) => {
		actions.setData(
			state.data.map((item) =>
				item.managementCompanyId === managementCompanyId ? { ...item, cif: target.value } : item
			)
		);
	};

	return (
		<TextField
			value={cif ?? ""}
			size='small'
			sx={{ width: 150 }}
			placeholder='Añade un CIF'
			onChange={handleOnChangeisin}
		/>
	);
}
